import React, { FC, useCallback } from 'react'
import { Grid, Box } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import MailIcon from '@mui/icons-material/Mail'
import { toast } from 'react-toastify'

const useStyle = makeStyles((theme: Theme) => ({
  copy: {
    color: theme.palette.secondary.light,
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  email: {
    marginLeft: 8,
  },
}))

export const CopyEmail: FC = () => {
  const classes = useStyle()
  const copyClipboard = useCallback((event) => {
    event.preventDefault()
    const email = event.currentTarget.innerText
    navigator.clipboard.writeText(email).then()
    toast(`Copy ${email}`, { type: 'success' })
  }, [])

  return (
    <Grid container direction="row" className={classes.copy}>
      <MailIcon />
      <Box className={classes.email} onClick={copyClipboard}>
        concierge@sparlingfinancial.com
      </Box>
    </Grid>
  )
}
